export function isTopRunner(item) {
  return item && ('redirectUrl' in item || 'brandLogo' in item);
}
